import React, { useEffect, useState } from "react";

import Form from "react-bootstrap/Form";
import { Link } from "react-router-dom";
import Select from "react-select";
import { IndexUse } from "./IndexUse";
import { IDS } from "../../../../utils/IDS";
import {
  GetSingle,
  Update,
  Create,
  GetAll,
} from "../../../../features/admin/master/vehiclecategory/Slice";
import { useDispatch, useSelector } from "react-redux";
import classNames from "classnames";
import { Controller, useForm } from "react-hook-form";
import Successfull_Modal from "../../../common-components/common_Modal/Successfull_Modal/Successfull_Modal";
import Add_section_title from "../../../common-components/add-section-title/Add_section_title";
import { getAllVehicleType } from "../../../../features/admin/common/Slice";

const Add = ({ id, setId, setShowError, setSuccess, setErr }) => {
  const [modalShow, setModalShow] = React.useState(false);
  const dispatch = useDispatch();

  const vehicletypeList = useSelector((state) => state.common.all_vehicle_type);

  useEffect(() => {
    dispatch(getAllVehicleType());
  }, [dispatch]);

  const {
    register,
    handleSubmit,
    clearErrors,
    setValue,
    getValues,
    setError,
    control,
    watch,
    formState: { errors },
    reset,
    image_required = true,
  } = useForm();
  const imageFile = watch("image");
  const map_iconFile = watch("map_icon");

  const GetData = async (id) => {
    try {
      const res = await dispatch(GetSingle(id));
      if (res.meta.requestStatus === "fulfilled") {
        reset(res?.payload?.data?.data);
      }
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    if (id) {
      GetData(id);
    }
  }, [id]);

  const selectedType = watch("type");

  const onSubmit = async (data) => {
    try {
      const sendData = new FormData();
      sendData.append("name", data?.name);
      sendData.append("type", data?.type);

      if (data?.type === "Transport") {
        sendData.append("capacity", data?.capacity || "");
        sendData.append("seat", "");
      } else if (data?.type === "Cab") {
        sendData.append("capacity", "");
        sendData.append("seat", data?.seat || "");
      } else if (data?.type === "Share") {
        sendData.append("capacity", "");
        sendData.append("seat", data?.seat || "");
      }

      sendData.append("image", data?.image[0]);
      sendData.append("map_icon", data?.map_icon[0]);
      sendData.append("vehicle_type_id", data?.vehicle_type_id?.value);

      let response;
      if (id) {
        response = await dispatch(Update({ id: id, data: sendData }));
      } else {
        response = await dispatch(Create(sendData));
      }
      if (response.meta.requestStatus === "fulfilled") {
        await dispatch(GetAll());
        await setId("");
        setSuccess(true);
        setModalShow(true);
        reset({
          name: "",
          type: "",
          capacity: "",
          seat: "",
          vehicle_type_id: null,
        });
        setTimeout(() => {
          setSuccess(false);
          setModalShow(false);
        }, 3000);
      } else if (response.meta?.requestStatus === "rejected") {
        setShowError(response.payload?.response?.data?.errors);
      }

      if (response.payload == 406) {
        await setError("name", {
          type: "manual",
          message: "Vehicle Category Already Exists",
        });
      }
    } catch (error) {
      setErr(true);
      console.error("error in Add Namee", error);
    }
  };

  const typeOptions = [
    { value: "Transport", label: "Transport" },
    { value: "Cab", label: "Cab" },
    { value: "Share", label: "Share" },
  ];

  return (
    <>
      <Add_section_title
        title={id ? "Edit Vehicle Category " : "Add Vehicle Category "}
        alltotal=""
      />
      <div className="forms_section">
        <Form onSubmit={handleSubmit(onSubmit)}>
          <div className="row">
            <div className="col-lg-6 col-md-6 mb-3">
              <div className="form-group">
                <Form.Label>Vehicle Type</Form.Label>
                <Controller
                  name="vehicle_type_id"
                  control={control}
                  rules={{
                    required: "Select Vehicle Type",
                  }}
                  render={({ field }) => (
                    <Select
                      {...field}
                      options={vehicletypeList}
                      placeholder="Select Vehicle Type"
                      onChange={(selectedOption) => {
                        field.onChange(selectedOption);
                        clearErrors("vehicle_type_id");

                        const match = selectedOption?.label.match(/\((.*?)\)/);

                        if (match && match[1]) {
                          setValue("type", match[1]);
                        }
                      }}
                    />
                  )}
                />
                {errors.vehicle_type_id && (
                  <span className="text-danger">
                    {errors.vehicle_type_id.message}
                  </span>
                )}
              </div>
            </div>

            <div className="col-lg-6 col-md-6 mb-3">
              <div className="form-group">
                <Form.Label>Name</Form.Label>

                <Form.Control
                  type="text"
                  placeholder="Name"
                  maxLength={80}
                  {...register("name", {
                    required: "Name is Required",
                    maxLength: {
                      value: 80,
                      message: "Maximum 80 characters allowed",
                    },
                  })}
                  className={classNames("", {
                    "is-invalid": errors?.name,
                  })}
                />

                <div className="d-flex justify-content-between">
                  {errors.name ? (
                    <span className="text-danger">{errors.name?.message}</span>
                  ) : (
                    <span />
                  )}

                  <small className="text-muted">
                    {watch("name")?.length || 0}/80
                  </small>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 mb-3">
              <div className="form-group">
                <Form.Label>Type</Form.Label>

                <Controller
                  name="type"
                  control={control}
                  rules={{
                    required: "Type is required",
                  }}
                  render={({ field }) => (
                    <Select
                      {...field}
                      options={typeOptions}
                      placeholder="Select Type"
                      value={
                        typeOptions.find(
                          (option) => option.value === field.value,
                        ) || null
                      }
                      onChange={(selectedOption) =>
                        field.onChange(selectedOption.value)
                      }
                      className={classNames({
                        "is-invalid": errors?.type,
                      })}
                    />
                  )}
                />

                {errors.type && (
                  <span className="text-danger">{errors.type.message}</span>
                )}
              </div>
            </div>
            <div className="col-lg-6 col-md-6 mb-3">
              {selectedType === "Transport" && (
                <div className="form-group">
                  <Form.Label>Capacity</Form.Label>
                  <Form.Control
                    type="number"
                    placeholder="Capacity"
                    {...register("capacity", {
                      required: "Capacity is required",
                      min: {
                        value: 0,
                        message: "Seat cannot be negative",
                      },
                    })}
                    className={classNames("", {
                      "is-invalid": errors?.capacity,
                    })}
                  />
                  {errors.capacity && (
                    <span className="text-danger">
                      {errors.capacity?.message}
                    </span>
                  )}
                </div>
              )}
            </div>
            <div className="col-lg-6 col-md-6 mb-3">
              {(selectedType === "Cab" || selectedType === "Share") && (
                <div className="form-group">
                  <Form.Label>Seat</Form.Label>

                  <Form.Control
                    type="number"
                    placeholder="Seat"
                    min={0}
                    {...register("seat", {
                      required: "Seat is required",
                      min: {
                        value: 0,
                        message: "Seat cannot be negative",
                      },
                    })}
                    className={classNames("", {
                      "is-invalid": errors?.seat,
                    })}
                  />

                  {errors.seat && (
                    <span className="text-danger">{errors.seat?.message}</span>
                  )}
                </div>
              )}
            </div>
            <div className="col-lg-6 col-md-6 mb-3">
              <Form.Group
                className="form-field mb-3"
                controlId="formBasicEmail"
              >
                <Form.Label>Image</Form.Label>
                <Form.Control
                  className={classNames("", {
                    "is-invalid": errors?.image,
                  })}
                  type="file"
                  {...register("image", {
                    // required: image_required
                    //   ? "Image is required"
                    //   : image_required,
                    required:
                      typeof getValues("image") == "string"
                        ? false
                        : " Image is required",
                    validate: async (value) => {
                      // if (typeof value !== "string") {
                      //   const fileTypes = ["jpg", "png", "jpeg"];
                      //   const fileType = value[0].name?.split(".")[1];
                      //   if (!fileTypes.includes(fileType)) {
                      //     return `please upload a valid file format. (${fileTypes})`;
                      //   }
                      // }
                    },
                  })}
                  //   {...register("image", {
                  //     validate: (value) => {
                  //       const currentImage = getValues("image");

                  //       if (
                  //         image_required &&
                  //         typeof currentImage !== "string" &&
                  //         (!value || value.length === 0)
                  //       ) {
                  //         return "Image is required";
                  //       }

                  //       return true;
                  //     },
                  //   })}
                  accept=".jpg, .jpeg, .png"
                />
                {errors.image && (
                  <span className="text-danger">{errors.image.message}</span>
                )}
              </Form.Group>
            </div>
            <div className="col-lg-6 col-md-6 mb-3">
              <Form.Group className="mb-3">
                <Form.Label className="text-center">Image Preview</Form.Label>
                {typeof getValues("image") == "string" ? (
                  <div className="image-preview-container">
                    <img
                      src={IDS.IMG_URL + getValues("image")}
                      alt="Preview"
                      className="image-preview"
                      style={{ width: "150px", height: "130px" }}
                    />
                  </div>
                ) : (
                  imageFile &&
                  imageFile?.length > 0 && (
                    <div className="image-preview-container">
                      <img
                        // src={URL.createObjectURL(getValues("image")[0])}
                        src={URL?.createObjectURL(imageFile[0])}
                        alt="Preview"
                        className="image-preview"
                        style={{ width: "100px", height: "100px" }}
                      />
                    </div>
                  )
                )}
              </Form.Group>
            </div>
            <div className="col-lg-6 col-md-6 mb-3">
              <Form.Group
                className="form-field mb-3"
                controlId="formBasicEmail"
              >
                <Form.Label>Map Icon</Form.Label>
                <Form.Control
                  className={classNames("", {
                    "is-invalid": errors?.map_icon,
                  })}
                  type="file"
                  {...register("map_icon", {
                    // required: image_required
                    //   ? "Image is required"
                    //   : image_required,
                    required:
                      typeof getValues("map_icon") == "string"
                        ? false
                        : " Image is required",
                    validate: async (value) => {
                      // if (typeof value !== "string") {
                      //   const fileTypes = ["jpg", "png", "jpeg"];
                      //   const fileType = value[0].name?.split(".")[1];
                      //   if (!fileTypes.includes(fileType)) {
                      //     return `please upload a valid file format. (${fileTypes})`;
                      //   }
                      // }
                    },
                  })}
                  //   {...register("image", {
                  //     validate: (value) => {
                  //       const currentImage = getValues("image");

                  //       if (
                  //         image_required &&
                  //         typeof currentImage !== "string" &&
                  //         (!value || value.length === 0)
                  //       ) {
                  //         return "Image is required";
                  //       }

                  //       return true;
                  //     },
                  //   })}
                  accept=".jpg, .jpeg, .png"
                />
                {errors.map_icon && (
                  <span className="text-danger">{errors.map_icon.message}</span>
                )}
              </Form.Group>
            </div>
            <div className="col-lg-6 col-md-6 mb-3">
              <Form.Group className="mb-3">
                <Form.Label className="text-center">Image Preview</Form.Label>
                {typeof getValues("map_icon") == "string" ? (
                  <div className="image-preview-container">
                    <img
                      src={IDS.IMG_URL + getValues("map_icon")}
                      alt="Preview"
                      className="image-preview"
                      style={{ width: "150px", height: "130px" }}
                    />
                  </div>
                ) : (
                  map_iconFile &&
                  map_iconFile?.length > 0 && (
                    <div className="image-preview-container">
                      <img
                        // src={URL.createObjectURL(getValues("image")[0])}
                        src={URL?.createObjectURL(map_iconFile[0])}
                        alt="Preview"
                        className="image-preview"
                        style={{ width: "100px", height: "100px" }}
                      />
                    </div>
                  )
                )}
              </Form.Group>
            </div>
          </div>

          <div className="form_submit_div ">
            <div className="row">
              <div className="col-lg-4 mx-auto mb-3">
                <div className="button_group">
                  <button
                    type="button"
                    className="closebtn theme_bg"
                    onClick={() => {
                      reset({
                        name: "",
                        type: null,
                        capacity: "",
                        seat: "",
                        image: null,
                        map_icon: null,
                      });

                      clearErrors();

                      setId("");
                    }}
                  >
                    Clear
                  </button>
                  <button
                    type="button"
                    className="addbtn"
                    onClick={handleSubmit(onSubmit)}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Form>
      </div>
      <Successfull_Modal
        message={"Successful"}
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
    </>
  );
};

export default Add;
